import React from 'react'
import {
    ThemeProvider,
    createTheme,
    responsiveFontSizes,
} from '@mui/material/styles'
import { themeOptionsLight, themeOptionsDark } from '../themeOptions'
import CssBaseline from '@mui/material/CssBaseline'
import { esES as coreesES } from '@mui/material/locale'
import { esES } from '@mui/x-date-pickers/locales'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'

/**
 *
 * Wraps example content in the dynamically controlled theme
 * set by the theme editor sidebar
 */
const ThemeWrapper = ({ mode, children }) => {
    const cache = createCache({ key: 'css', prepend: true })
    return (
        <CacheProvider value={cache}>
            <ThemeProvider
                theme={responsiveFontSizes(
                    createTheme(
                        mode === 'light' ? themeOptionsLight : themeOptionsDark,
                        esES,
                        coreesES
                    )
                )}
            >
                <CssBaseline />
                {children}
            </ThemeProvider>
        </CacheProvider>
    )
}

export default ThemeWrapper
